export enum ElementSize {
	Small,
	Medium,
	Large
}
